module.exports = __webpack_public_path__ + "img/15.4395241b.svg";